// Kallesignal-katalog / hierarkisk adressebok. Bygger en søkbar liste over alle
// adresserbare HV-enheter (distrikter + tradisjonelle områder) fra hv-structure,
// med rollens Matrix-identitet (@skade_…) slik at man kan slå opp «hvem er
// HV-11-203» og sende 1:1 dit. Ren, testbar logikk; ingen egen datakilde utover
// den kanoniske HV-strukturen (én kilde til sannhet).
import { HV_DISTRICTS, allAreas } from './hv-structure.js';
import { skadeMatrixUserId } from './gna-link.js';
let _dir = null;
/** Hele adresseboken (distrikter + områder), sortert distrikt→område. */
export function orgDirectory() {
    if (_dir)
        return _dir;
    const out = [];
    for (const d of HV_DISTRICTS) {
        out.push({
            id: d.id, kind: 'distrikt', label: `${d.id} · ${d.name} (distriktsstab)`,
            district: d.id, echelon: 'brigade', matrixUserId: skadeMatrixUserId(d.id),
            haystack: `${d.id} ${d.name} ${d.hq} distriktsstab`.toLowerCase(),
        });
    }
    for (const a of allAreas()) {
        out.push({
            id: a.id, kind: 'område', label: `${a.id} · ${a.name}`,
            district: a.district, area: a.name, echelon: 'kompani',
            matrixUserId: skadeMatrixUserId(a.id), municipalities: a.municipalities,
            haystack: `${a.id} ${a.name} ${a.district} ${a.municipalities.join(' ')}`.toLowerCase(),
        });
    }
    _dir = out;
    return out;
}
/** Søk i adresseboken (navn, id, kommune, distrikt). Tom streng = alt. */
export function searchDirectory(query, limit = 50) {
    const q = query.trim().toLowerCase();
    const all = orgDirectory();
    const hits = q ? all.filter((e) => e.haystack.includes(q)) : all;
    return hits.slice(0, limit);
}
/** Slå opp én enhet på id («HV-11-203»). */
export function directoryEntry(id) {
    return orgDirectory().find((e) => e.id === id);
}
//# sourceMappingURL=directory.js.map